const date = require('./libs/date')

function programDateTime(str) {
  return date(str)
}

module.exports = programDateTime
